// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import {
//   signInWithPopup,
//   signOut,
//   onAuthStateChanged,
//   signInWithRedirect,
//   getRedirectResult,
// } from 'firebase/auth';
// import { auth, googleProvider } from '../firebase/config';

// export const signInWithGoogle = createAsyncThunk(
//   'auth/signInWithGoogle',
//   async (useRedirect = false, thunkAPI) => {
//     try {
//       if (useRedirect) {
//         await signInWithRedirect(auth, googleProvider);
//       } else {
//         const result = await signInWithPopup(auth, googleProvider);
//         return result.user;
//       }
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.message);
//     }
//   }
// );

// // Async thunk for logout
// export const logout = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
//   try {
//     await signOut(auth);
//     return null;
//   } catch (error) {
//     return thunkAPI.rejectWithValue(error.message);
//   }
// });

// // Auth state listener thunk (called once on app init)
// export const observeAuthState = createAsyncThunk(
//   'auth/observeAuthState',
//   async (_, thunkAPI) => {
//     return new Promise((resolve) => {
//       onAuthStateChanged(auth, (user) => {
//         resolve(user || null);
//       });
//     });
//   }
// );

// // Get redirect result (for mobile)
// export const handleRedirectResult = createAsyncThunk(
//   'auth/handleRedirectResult',
//   async (_, thunkAPI) => {
//     try {
//       const result = await getRedirectResult(auth);
//       return result?.user || null;
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.message);
//     }
//   }
// );

// const authSlice = createSlice({
//   name: 'auth',
//   initialState: {
//     user: false,
//     accessToken: null,
//     name: null,
//     email: null,
//     phoneNumber: null,
//     photoURL: null,
//     uid: null,
//     loading: false,
//     error: null,
//     isAuthenticated: false,
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     builder
//       .addCase(signInWithGoogle.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//       .addCase(signInWithGoogle.fulfilled, (state, action) => {

//         state.loading = false;
//         state.user = true;
//         state.accessToken = action.payload.accessToken,
//         state.name = action.payload.displayName,
//         state.email = action.payload.email,
//         state.phoneNumber = action.payload.phoneNumber,
//         state.photoURL = action.payload.photoURL,
//         state.uid = action.payload.uid,
//         state.isAuthenticated = !!action.payload;
//       })
//       .addCase(signInWithGoogle.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.payload;
//       })
//       .addCase(logout.fulfilled, (state) => {
//         state.user = false;
//         state.user = true;
//         state.accessToken = null,
//         state.name = null,
//         state.email = null,
//         state.phoneNumber = null,
//         state.photoURL = null,
//         state.uid = null,
//         state.isAuthenticated = false;
//         state.loading = false;
//       })
//     //   .addCase(handleRedirectResult.fulfilled, (state, action) => {
//     //     state.user = action.payload;
//     //     state.isAuthenticated = !!action.payload;
//     //     state.loading = false;
//     //   })
//     //   .addCase(observeAuthState.pending, (state) => {
//     //     state.loading = true;
//     //   })
//     //   .addCase(observeAuthState.fulfilled, (state, action) => {
//     //     state.user = action.payload;
//     //     state.isAuthenticated = !!action.payload;
//     //     state.loading = false;
//     //   });
//   },
// });

// export default authSlice.reducer;

// src/store/slices/authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  signInWithPopup,
  signOut,
  onAuthStateChanged,
  signInWithRedirect,
  getRedirectResult,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
} from 'firebase/auth';
import { auth, googleProvider } from '../firebase/config';

// Initialize auth persistence
export const initializeAuthPersistence = createAsyncThunk(
  'auth/initializeAuthPersistence',
  async (persistenceType = 'local', thunkAPI) => {
    try {
      const persistence = persistenceType === 'local' 
        ? browserLocalPersistence 
        : browserSessionPersistence;
      
      await setPersistence(auth, persistence);
      // console.log(`Auth persistence set to ${persistenceType}`);
      return persistenceType;
    } catch (error) {
      console.error('Error setting persistence:', error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Auth state observer
export const observeAuthState = createAsyncThunk(
  'auth/observeAuthState',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      return new Promise((resolve) => {
        const unsubscribe = onAuthStateChanged(
          auth,
          (user) => {
            if (user) {
              // Store user data in localStorage for persistence
              const userData = {
                uid: user.uid,
                email: user.email,
                displayName: user.displayName,
                photoURL: user.photoURL,
                phoneNumber: user.phoneNumber,
                emailVerified: user.emailVerified,
                accessToken: user.accessToken,
                creationTime: user.metadata.creationTime,
                lastSignInTime: user.metadata.lastSignInTime,
              };
              localStorage.setItem('userData', JSON.stringify(userData));
              resolve(user);
            } else {
              localStorage.removeItem('userData');
              resolve(null);
            }
          },
          (error) => {
            console.error('Auth state change error:', error);
            resolve(null);
          }
        );
        
        // Store unsubscribe function for cleanup
        window.authUnsubscribe = unsubscribe;
      });
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Sign in with Google
export const signInWithGoogle = createAsyncThunk(
  'auth/signInWithGoogle',
  async ({ useRedirect = false, rememberMe = true } = {}, thunkAPI) => {
    try {
      // Set persistence based on user preference
      const persistence = rememberMe ? browserLocalPersistence : browserSessionPersistence;
      await setPersistence(auth, persistence);
      
      if (useRedirect) {
        await signInWithRedirect(auth, googleProvider);
        return null; // Result will be handled by redirect result
      } else {
        const result = await signInWithPopup(auth, googleProvider);
        
        // Get additional user info
        const user = result.user;
        const token = await user.getIdToken();
        
        return {
          ...user,
          accessToken: token,
          uid: user.uid,
          email: user.email,
          displayName: user.displayName,
          photoURL: user.photoURL,
          phoneNumber: user.phoneNumber,
          emailVerified: user.emailVerified,
        };
      }
    } catch (error) {
      console.error('Sign-in error:', error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Handle redirect result
export const handleRedirectResult = createAsyncThunk(
  'auth/handleRedirectResult',
  async (_, thunkAPI) => {
    try {
      const result = await getRedirectResult(auth);
      if (result?.user) {
        const token = await result.user.getIdToken();
        return {
          ...result.user,
          accessToken: token,
        };
      }
      return null;
    } catch (error) {
      console.error('Redirect result error:', error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// Logout
export const logout = createAsyncThunk('auth/logout', async (_, thunkAPI) => {
  try {
    await signOut(auth);
    localStorage.removeItem('userData');
    sessionStorage.removeItem('userInfo');
    return null;
  } catch (error) {
    console.error('Logout error:', error);
    return thunkAPI.rejectWithValue(error.message);
  }
});

// Restore user from localStorage (for app initialization)
export const restoreUserFromStorage = createAsyncThunk(
  'auth/restoreUserFromStorage',
  async (_, thunkAPI) => {
    try {
      const storedUserData = localStorage.getItem('userData');
      if (storedUserData && auth.currentUser) {
        const userData = JSON.parse(storedUserData);
        // Verify the stored data matches current user
        if (userData.uid === auth.currentUser.uid) {
          return userData;
        }
      }
      return null;
    } catch (error) {
      console.error('Error restoring user from storage:', error);
      return null;
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    accessToken: null,
    name: null,
    email: null,
    phoneNumber: null,
    photoURL: null,
    uid: null,
    emailVerified: false,
    loading: true,
    error: null,
    isAuthenticated: false,
    initialized: false,
    persistenceType: 'local',
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Initialize persistence
      .addCase(initializeAuthPersistence.fulfilled, (state, action) => {
        state.persistenceType = action.payload;
      })
      .addCase(initializeAuthPersistence.rejected, (state, action) => {
        state.error = action.payload;
      })
      
      // Observe auth state
      .addCase(observeAuthState.pending, (state) => {
        state.loading = true;
      })
      .addCase(observeAuthState.fulfilled, (state, action) => {
        const user = action.payload;
        if (user) {
          state.user = user;
          state.accessToken = user.accessToken || null;
          state.name = user.displayName;
          state.email = user.email;
          state.phoneNumber = user.phoneNumber;
          state.photoURL = user.photoURL;
          state.uid = user.uid;
          state.emailVerified = user.emailVerified;
          state.isAuthenticated = true;
        } else {
          // Reset state on logout
          state.user = null;
          state.accessToken = null;
          state.name = null;
          state.email = null;
          state.phoneNumber = null;
          state.photoURL = null;
          state.uid = null;
          state.emailVerified = false;
          state.isAuthenticated = false;
        }
        state.loading = false;
        state.initialized = true;
      })
      .addCase(observeAuthState.rejected, (state, action) => {
        state.loading = false;
        state.initialized = true;
        state.error = action.payload;
      })
      
      // Sign in with Google
      .addCase(signInWithGoogle.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(signInWithGoogle.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload) {
          const user = action.payload;
          state.user = user;
          state.accessToken = user.accessToken;
          state.name = user.displayName;
          state.email = user.email;
          state.phoneNumber = user.phoneNumber;
          state.photoURL = user.photoURL;
          state.uid = user.uid;
          state.emailVerified = user.emailVerified;
          state.isAuthenticated = true;
        }
      })
      .addCase(signInWithGoogle.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Handle redirect result
      .addCase(handleRedirectResult.fulfilled, (state, action) => {
        if (action.payload) {
          const user = action.payload;
          state.user = user;
          state.accessToken = user.accessToken;
          state.name = user.displayName;
          state.email = user.email;
          state.phoneNumber = user.phoneNumber;
          state.photoURL = user.photoURL;
          state.uid = user.uid;
          state.emailVerified = user.emailVerified;
          state.isAuthenticated = true;
        }
        state.loading = false;
      })
      .addCase(handleRedirectResult.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Logout
      .addCase(logout.pending, (state) => {
        state.loading = true;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.accessToken = null;
        state.name = null;
        state.email = null;
        state.phoneNumber = null;
        state.photoURL = null;
        state.uid = null;
        state.emailVerified = false;
        state.isAuthenticated = false;
        state.loading = false;
        state.error = null;
      })
      .addCase(logout.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      
      // Restore user from storage
      .addCase(restoreUserFromStorage.fulfilled, (state, action) => {
        if (action.payload) {
          const user = action.payload;
          state.accessToken = user.accessToken;
          state.name = user.displayName;
          state.email = user.email;
          state.phoneNumber = user.phoneNumber;
          state.photoURL = user.photoURL;
          state.uid = user.uid;
          state.emailVerified = user.emailVerified;
        }
      });
  },
});

export const { clearError, setLoading } = authSlice.actions;
export default authSlice.reducer;